import script from "./GoalPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./GoalPlan.vue?vue&type=script&setup=true&lang=js"

import "./GoalPlan.vue?vue&type=style&index=0&id=59851d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59851d06"]])

export default __exports__